import { useState } from 'react'

import { useTranslate } from '../../hooks/useTranslate'

type Props = {
  maxLength: number
  children: string
}

export const CollapsedText = ({ maxLength, children }: Props) => {
  const translate = useTranslate()
  const [isCollapsed, setIsCollapsed] = useState(true)
  const textLength = children.length
  const isTruncated = textLength > maxLength
  const renderedText = isCollapsed
    ? `${children.slice(0, maxLength)}${isTruncated ? '\u2026' : ''}`
    : children

  return (
    <span>
      {renderedText}
      {isTruncated && (
        <button
          className="ml-2 font-semibold underline"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {isCollapsed
            ? translate('collapsedText.show')
            : translate('collapsedText.hide')}
        </button>
      )}
    </span>
  )
}
